import styled from "styled-components";
import { ClubDescriptionWidget } from "../InfoButton/styles";

export const Container = styled(ClubDescriptionWidget)`
	background: rgba(0, 0, 0, 0.5);
	padding: 0.5em 0.7em 0.6em;
	opacity: 0.9;
	font-size: 1.265em;
	display: flex;
	align-items: center;
	justify-content: center;
	min-height: 22px;

	p {
		color: #fff;
		line-height: 100%;
		font-size: 1.265em;
		padding: 0;
	}

	&.portrait {
		padding: 0.5em 0.7em 0.6em;
		font-size: 1.1em;

		p {
			font-size: 1.1em;
		}
	}
`;
